<template>
  <el-dialog :visible.sync="dialogVisible" width="1260px" :append-to-body="true" title="Stackup Calculator" top="5vh" :close-on-click-modal="false" custom-class="stackup-calc-dialog">
    <div class="impedance">
        <impedance-pressing ref="impedancePressing" :orderParams="orderParams" :value="pressing" :pressingList="pressingList" :key="refreshNum" @syncPressing="syncPressing" @isLoading="handleIsLoading"></impedance-pressing>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="isLoading" @click="handleReset">Reset</el-button>
      <el-button type="primary" :disabled="isLoading" @click="handleCalc">Calculate</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ImpedancePressing from './impedance-pressing.vue'
export default {
  components: {
    ImpedancePressing
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: String,
      default: 'dialog'
    },
    orderParams: {
      type: Object,
      default: () => ({})
    },
    pressing: {
      type: String,
      default: ''
    },
    pressingList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      this.$emit('input', newValue)
    },
    value(newValue, oldValue) {
      this.dialogVisible = newValue
    }
  },
  data() {
    return {
      dialogVisible: this.value,
      show: true,
      currentValue: '',
      defaultOrderParams: {
        blayer: 4,
        bheight: 1.6,
        copper: 1,
        insidecopper: 0.5,
        hdi: 0
      },
      refreshNum: 0,
      isLoading: false
    }
  },
  mounted() {},
  methods: {
    handleCompute(data) {
      this.$emit('compute', data)
    },
    handleInput(val) {
      this.currentValue = val
    },
    handleCalc() {
      this.$refs.impedancePressing.handleValidate()
    },
    handleReset() {
      this.refreshNum ++
    },
    syncPressing(val) {
      this.$emit('syncPressing', val)
    },
    handleIsLoading(val) {
      this.isLoading = val
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .stackup-calc-dialog {
    .el-dialog__header {
      background: #c00;
      color: #FFF;
      font-weight: 700;
      padding: 10px 20px;
      .el-dialog__title {
        color: #FFF;
      }

      .el-dialog__headerbtn {
        top: 10px;
        font-size: 18px;
        font-weight: 700;

        .el-dialog__close {
          color: #FFF;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>

<style lang="scss">
// @import '../ui/var.scss';

$border: 1px solid #dcdfe6;
$mainColor: #c00;
$mainColor-hover: #b80000;
$warningColor: #e58810;
$warningColor-hover: #ff9812;

$textColor-main: #333333;
$textColor-secondary: #666666;
$textColor-placeholder: #999999;
$bgColor: #f5f5f5;

// 修改 el-table 样式
.impedance-table {
  font-size: 12px;
  border: 0;
  border-top: $border;
  border-left: $border;
  thead th.is-leaf {
    background-color: #f5f7fa;
  }
  th,
  td {
    padding: 4px 0 !important;
    border: 0 !important;
    border-right: $border !important;
    border-bottom: $border !important;
  }

  th {
    color: #333;
    .cell {
      font-weight: 700;
      word-break: break-word;
      line-height: 20px;
    }
  }

}

// 选择叠层结构表格 下拉框
.impedance__params__select {
  .el-select-dropdown__item.selected {
    color: $mainColor;
  }
}

.impedance {
  // background-color: $bgColor;
  // padding-top: 1px;

  max-height: calc(100vh - 200px);
  overflow: auto;

  .impedance__container {
    margin: 0 auto;
    width: 1400px;
    min-height: 600px;
  }

  .el-button--primary {
    background: $mainColor;
    border-color: $mainColor;

    &:hover {
      background: $mainColor-hover;
      border-color: $mainColor-hover;
    }

    &.is-disabled {
      color: #666666;
      background-color: #dcdfe6;
      border-color: #dcdfe6;
    }
  }

  // 头部
  .impedance__header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // height: 40px;
    background-color: #fff;
    padding: 10px;
    > img {
      margin-right: 30px;
      height: 24px;
    }
    > h1 {
      font-size: 16px;
      font-weight: 700;
      color: $textColor-main;
    }
    > p {
      color: #333;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .impedance__title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 700;
    color: $textColor-main;
  }

  // 计算叠层结构参数
  .impedance__params {
    // margin: 10px 0;
    padding: 10px 20px;
    border-radius: 4px;
    background-color: #fff;

    .impedance__params__order {
      display: flex;
      // border: $border;
      // border-right: 0;
      color: #333;
      > li {
        display: flex;
        width: 25%;
        line-height: 32px;
        > span {
          display: block;
          // border-right: $border;
          .default {
            padding-left: 15px;
          }
          &:first-child {
            // padding-left: 10px;
            width: 50%;
            font-size: 12px;
            // color: $textColor-secondary;
            // background-color: #f5f7fa;
          }
          &:last-child {
            flex: 1;
            color: #b8802c;
            .el-input__inner {
              border: 0;
            }
            .el-input__suffix {
              line-height: 28px;
            }
          }
        }
      }
    }

    .impedance__params__stackup {
      margin: 20px 0;
      display: flex;
      align-items: center;
      color: #333;

      p {
        margin-right: 60px;
      }
    }

    .impedance__params__btns {
      display: flex;
      align-items: center;
      margin: 20px 0;
      .el-input-group {
        margin-right: 10px;
        width: 116px;
      }
      > p {
        margin-left: 10px;
      }
    }

    // 叠层结构列表
    .impedance__params__list {
      .el-input,
      .el-select {
        .el-input__inner {
          // border: 0;
        }
      }

      .el-input-number {
        width: 100%;
        .el-input__inner {
          text-align: left;
        }
        &.error {
          .el-input__inner {
            border: 1px solid $mainColor;
          }
        }
      }
    }
  }

  .impedance__list {
    padding: 16px 20px 20px;
    border-radius: 4px;
    background-color: #fff;
    .impedance__list__item {
      margin-bottom: 20px;
      border-radius: 2px;
      border: 1px solid #e8efff;
      // box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.16);
      .impedance__list__item_title {
        padding:0 0 0 20px;
        line-height: 20px;
        border-bottom: 1px solid #e8efff;
        display: flex;
        align-items: center;
        min-height: 36px;
        p {
          font-size: 14px;
          font-weight: 700;
          color: #333;
          margin-right: 20px;
          white-space: nowrap;
        }

        span {
          word-break: break-word;
        }
      }
      > div {
        padding: 10px 20px 20px;
      }
    }

    .is-checked {
      border-color: #b8741a;
      background-color: #fcf8f4;
      .impedance__list__item_title {
        background-color: #f9f1e9;
      }
    }

    .impedance__list__noData {
      padding: 50px;
      text-align: center;
      font-size: 16px;
      color: $textColor-placeholder;
    }

    .impedance__list__item__tips {
      color: #b8802c;
    }
  }
}

// 阻抗表
.impedance-table__table {
  margin-bottom: 10px;

  .impedance-table__table__tips {
    margin-bottom: 10px;
    color: $warningColor;
  }

  .el-table__header .impedance-table__table__bgColor {
    color: $textColor-main;
    background-color: #cccfd4;
  }

  .el-table__body {
    tr:hover .default {
      background-color: #f5f7fa;
    }

    .impedance-table__table__bgColor {
      position: relative;
      padding: 0;
      .cell {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0;
      }
      .default {
        padding-left: 6px;
        padding-right: 6px;
        line-height: 32px;
        height: 100%;
        background-color: #ffffff;
        display: flex;
        align-items: center;

        &.red {
          color: #ffffff;
          background-color: $mainColor;
        }

        &.green {
          color: #ffffff;
          background-color: #059a58;
        }
        &.red_font {
          color: $mainColor;
        }
      }
    }
  }
}

// 压合结构
.impedance-stack {
  &__0 {
    height: 6px;
    background-color: #6f4c1b;
  }
  &__1 {
    height: 6px;
    background-color: #f4bb69;
  }
  &__2 {
    padding: 6px 0;
    height: 32px;
    background-color: #f4bb69;
    > div {
      line-height: 20px;
      height: 20px;
      text-align: center;
      color: #ffffff;
      background-color: #6f4c1b;
    }
  }
  &__3 {
    height: 32px;
    background-color: #6f4c1b;
  }
}

/********* 文本提示组件 start ************/
.text-tip__handle {
  font-weight: 400;
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 1;
  border-radius: 100%;
  border: 1px solid #999;
  color: #999;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    color: $warningColor-hover;
    border-color: $warningColor-hover;
  }
}
.text-tip__icon {
  font-size: 14px;
  color: $textColor-placeholder;
  &:hover {
    color: #059a58;
  }
}
.text-tip.el-tooltip__popper {
  border: none;
  box-shadow: 0 1px 3px #ddd;
  .text-tip__content {
    line-height: 1.5;
    a {
      color: #059a58;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  $borderColor: #ddd !important;
  &[x-placement^='top'] .popper__arrow {
    border-top-color: $borderColor;
  }
  &[x-placement^='right'] .popper__arrow {
    border-right-color: $borderColor;
  }
  &[x-placement^='bottom'] .popper__arrow {
    border-bottom-color: $borderColor;
  }
  &[x-placement^='left'] .popper__arrow {
    border-left-color: $borderColor;
  }
}
/********* 文本提示组件 end ************/
</style>
